export const getScoreFromResponse = (response) => {
  return (
    response.fields.find((f) => f.label === 'Berlin questionnaire score')
      ?.value || response.fields.find((f) => f.id === 'score')?.answer
  );
};

export const getWeightFromResponse = (response) => {
  return (
    response.fields.find(
      (f) =>
        f.label === 'Weight' ||
        f.label === 'Quel est votre poids en kg ?' ||
        f.question === 'Quel est votre poids en kg ?',
    )?.value ||
    response.fields.find((f) => f.question === 'Quel est votre poids en kg ?')
      .answer
  );
};

export const getHeightFromResponse = (response) => {
  return (
    response.fields.find(
      (f) =>
        f.label === 'Height' || f.label === 'Quelle est votre taille en cm ?',
    )?.value ||
    response.fields.find(
      (f) => f.question === 'Quelle est votre taille en cm ?',
    )?.answer
  );
};

export const getBMIFromResponse = (response) => {
  return response.fields.find((f) => f.label === 'BMI')?.value;
};

export const getAgeFromResponse = (response) => {
  return (
    response.fields.find(
      (f) => f.label === 'Age' || f.label === 'Quel âge avez-vous ?',
    )?.value ||
    response.fields.find((f) => f.question === 'Quel âge avez-vous ?')?.answer
  );
};

export const getGenderFromResponse = (response) => {
  return (
    response.fields.find(
      (f) => f.label === 'Gender' || f.label === 'Quel est votre sexe ?',
    )?.value ||
    response.fields.find((f) => f.question === 'Quel est votre sexe ?')?.answer
  );
};
